import { useTranslation } from 'react-i18next';
import Card from '../Card/Card';
import type { BankruptcyJobSummaryDto } from '../../Containers/BankruptcyTermination.types';

const SummaryBar = ({ summary }: { summary: BankruptcyJobSummaryDto }) => {
    const { t } = useTranslation();
    const stats = [
        { label: t('bankruptcytermination.total'), value: summary.totalCustomers },
        { label: t('bankruptcytermination.succeeded'), value: summary.successfulCustomers },
        { label: t('bankruptcytermination.failed'), value: summary.failedCustomers },
        { label: t('bankruptcytermination.partial'), value: summary.partiallySuccessfulCustomers },
        { label: t('bankruptcytermination.skipped'), value: summary.skippedCustomers },
        { label: t('bankruptcytermination.subscriptionsterminated'), value: summary.totalSubscriptionsTerminated },
        { label: t('bankruptcytermination.subscriptionsfailed'), value: summary.totalSubscriptionsFailed },
        { label: t('bankruptcytermination.successrate'), value: `${summary.successRate.toFixed(1)}%` },
    ];
    return (
        <div className="d-flex flex-wrap gap-4 mb-4">
            {stats.map(({ label, value }) => (
                <Card key={label}>
                    <div className='pt-12 pb-12 pl-16 pr-16' style={{ minWidth: '130px' }}>
                        <div className="font-14">{label}</div>
                        <div className='font-weight-semibold font-16'>{value}</div>
                    </div>
                </Card>
            ))}
        </div>
    );
};

export default SummaryBar;
